<template>
  <div class="bulk-ticket-operation-section">
    <v-btn
      id="ticket-bulk-action"
      class="mr-4 pl-2 font-weight-bold"
      v-track="'ticket-bulk-action'"
      outlined
      @click="onBulkClick()"
    >
      <v-icon color="#000" class="mr-1">mdi-update</v-icon>
      Bulk Update
    </v-btn>
    <v-navigation-drawer
      v-model="bulkActionDrawer"
      class="px-6 pt-6 overflow-y-hidden pr-2"
      id="bulk-action-ticket-drawer"
      width="550px"
      right
      fixed
      temporary
    >
      <div id="scrollRef" class="mb-5 pr-8 pl-2">
        <v-row no-gutters>
          <v-col align="left">
            <h5 class="
                text-h5
                font-weight-medium-custom
                float-left
                text-capitalize
              ">
              <span class="secondary--font"> Bulk Update </span>
            </h5>
          </v-col>
          <v-col align="right">
            <v-btn
              icon
              @click.stop="onCancel()"
              class="float-right"
              v-track="'close-filter-drawer'"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12 py-2">
            <span class="body-1">
              You can make bulk changes to all selected tickets at once.
            </span>
          </v-col>
        </v-row>
        <v-card elevation="0">
          <v-form ref="bulkActionForm" class="mt-1">
            <v-card-text class="pa-0 body-1">
              <label class="secondary--font font-weight-600">Bulk Reply</label>
              <v-card width="480" class="ck-editor-card-border mt-2" outlined>
                <header class="d-flex justify-space-between flex-wrap pa-2">
                  <div class="d-flex align-center">
                    <span class="px-2 pl-1 grey--text text--darken-2 text-center">
                      From:
                    </span>
                    <v-menu offset-y attach>
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          color="blue"
                          v-bind="attrs"
                          v-on="on"
                          class="grey--text text--darken-2 d-flex"
                        >
                          {{ fromEmailAddress }}

                          <v-icon v-if="attrs['aria-expanded'] == 'false'">
                            mdi-menu-down
                          </v-icon>
                          <v-icon v-if="attrs['aria-expanded'] == 'true'">
                            mdi-menu-up
                          </v-icon>
                        </div>
                      </template>
                      <v-list>
                        <v-list-item-group>
                          <v-list-item
                            v-for="(item, index) in supportEmailList"
                            :key="index"
                            @click="setSupportEmail(item)"
                            v-track="'set-support-email'"
                          >
                            <v-list-item-title class="d-flex">
                              <div v-if="item.name" class="support-email-name pr-1">
                                {{ item.name | upperCaseFirst }}
                              </div>
                              <span class="grey--text text--darken-2"
                                >{{ item.email }}
                              </span></v-list-item-title
                            >
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-menu>
                  </div>
                  <div class="right-section d-flex">
                    <FileUploader page="ckeditor" @saveAttachment="saveAttachment">
                    </FileUploader>
                    <ReplyTemplate
                      @useTemplate="updateBody"
                      :ticket-data="selectedTickets[0]"
                      :parseTemplate="false"
                      :template-drawer-style="{
                        top: '0px !important'
                      }"
                    >
                    </ReplyTemplate>
                  </div>
                </header>
                <v-card-text class="pa-0">
                  <div>
                    <CKEditor
                      @update="getEditorHTML"
                      :body="editorHTML"
                      @onReady="getInstance"
                    >
                    </CKEditor>
                  </div>
                  <v-col
                    cols="12"
                    v-if="dropedFiles.length || attachmentFiles.length"
                    id="attachment-section"
                  >
                    <h6 class="text-subtitle-1">
                      <span class="secondary--font black--text">
                        Attachments ({{ dropedFiles.length + attachmentFiles.length }})
                      </span>
                    </h6>
                    <template v-for="(file, index) in [...dropedFiles, ...attachmentFiles]">
                      <v-chip
                        color="#CBDAE8"
                        :key="index"
                        class="ml-0 ma-2 mr-3"
                        close
                        @click:close="removeAttchment(file, file.file_name ? 'old' : 'new')"
                      >
                        {{ file.name ? file.name : file.file_name | upperCaseFirst }}
                      </v-chip>
                    </template>
                  </v-col>
                </v-card-text>
              </v-card>
              <div class="mt-2" v-if="!loadSupportEmail && supportEmailList.length == 0">
                <v-alert
                  icon="mdi-alert-circle-outline"
                  dense
                  color="#FFCDD2"
                  class="width-100 body-2 mb-0 pa-2 pl-3 error-icon-color"
                >
                  You cannot perform bulk replies because your support email ID is not set up or verified.
                </v-alert>
              </div>
              <div class="mt-6">
                <v-autocomplete
                  v-model="tags"
                  :items="tagList"
                  item-text="name"
                  item-value="id"
                  label="Tags"
                  no-data-text="No tag available"
                  :search-input.sync="tagSearch"
                  outlined
                  chips
                  clearable
                  deletable-chips
                  small-chips
                  multiple
                  hide-details
                  attach
                  cache-items
                  return-object
                  :loading="tagLoading"
                  :hide-no-data="tagLoading"
                  @change="enableUpdate()"
                  @update:search-input="searchTagItems"
                >
                  <template v-slot:append-item>
                    <v-btn
                      v-if="!tagLoading && tagSearch"
                      :loading="newTagLoading"
                      class="py-6 pl-3 d-flex justify-start text-left body-1 transform-none"
                      block
                      @click="onCreateTag"
                      v-track="'create-new-tag-btn'"
                      >
                      + Create New Tag
                    </v-btn>
                  </template>
                </v-autocomplete>
              </div>
              <div class="mt-6">
                <v-autocomplete
                  v-model="status"
                  :items="filterStatusList"
                  :item-text="(item) => item.name ? item.name.replace('_', ' ') : item.name"
                  item-value="value"
                  outlined
                  label="Status"
                  class="customize-select"
                  attach
                  return-object
                  hide-details
                  clearable
                  @change="enableUpdate()"
                >
                </v-autocomplete>
              </div>
              <div class="mt-6">
                <v-autocomplete
                  v-model="selectedAgent"
                  :items="associatedField.agentList" 
                  label="Agent"
                  class="customize-select"
                  outlined
                  return-object
                  item-text="agent_name"
                  item-value="id"
                  hide-details
                  attach
                  clearable
                  :no-filter="true"
                  :search-input.sync="searchAgentKeyword"
                  @change="enableUpdate()"
                >
                <template #item="{ item }">
                    <v-list-item-content 
                      v-if="item.id === 'blank'"
                      class="text-left transform-none body-1 ma-n4 pl-3 v-btn v-btn--has-bg theme--light"
                    >
                    <v-list-item-title>
                      Unassigned
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-content v-else>
                    <v-list-item-title>
                      {{ item.agent_name }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
                </v-autocomplete>
              </div>
              <div class="mt-6">
                <v-autocomplete
                  v-model="priority"
                  :items="associatedField.priorities"
                  item-text="name"
                  item-value="value"
                  label="Priority"
                  class="customize-select"
                  outlined
                  return-object
                  hide-details
                  search-input="false"
                  attach
                  clearable
                  @change="enableUpdate()"
                >
                </v-autocomplete>
              </div>
              <div class="mt-6">
                <v-autocomplete
                  v-model="type"
                  :items="associatedField.types.list"
                  item-text="name"
                  item-value="id"
                  autocomplete="off"
                  outlined
                  attach
                  label="Type"
                  return-object
                  hide-details
                  clearable
                  @change="enableUpdate()"
                >
                  <template #item="{ item }">
                      <v-list-item-content 
                        v-if="item.id === 'blank'"
                        class="text-left transform-none body-1 ma-n4 pl-3 v-btn v-btn--has-bg theme--light"
                      >
                      <v-list-item-title>
                        Unassigned
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-content v-else>
                      <v-list-item-title>
                        {{ item.name }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <template v-slot:append-item>
                    <div
                      v-intersect="loadMoreTicketTypes"
                      class="teal--text"
                    ></div>
                  </template>
                </v-autocomplete>
              </div>
            </v-card-text>
          </v-form>
        </v-card>
      </div>
      <template v-slot:append>
        <v-card-actions class="px-2 py-5 d-flex align-end">
          <v-btn
            class="font-weight-bold"
            v-track="'cancel-bulk-action'"
            @click.stop="onCancel()"
            outlined
          >
            Cancel
          </v-btn>
          <v-btn
            class="font-weight-bold"
            v-track="'bulk-action'"
            @click.stop="onUpdate()"
            :dark="actionButton"
            :disabled="!actionButton"
          >
            Update
          </v-btn>
          </v-card-actions>
      </template>
    </v-navigation-drawer>
    <!-- Confirmation action -->
    <dialog-box
      v-bind="dialog.attrs"
      v-on="dialog.on"
    />
  </div>
</template>

<script>
import { $mailbox, $tickets, $tag } from "@/services/Index";
import { ticketMixin } from "@/mixins/ticket";
import CKEditor from "@/components/ckeditor/Editor";
import FileUploader from "@/components/file_uploader/UploadFile";
import { attachmentfileactionMixin } from "@/mixins/attachmentFileAction.js";
import ReplyTemplate from "@/components/tickets/reply/TemplateDrawer";

export default {
  name: "filter-drawer",
  mixins: [ticketMixin, attachmentfileactionMixin],
  components: {
    CKEditor,
    FileUploader,
    ReplyTemplate
  },
  props: {
    selectedTickets: {
      type:[Array, Object],
      default: ()=> ([])
    },
  },
  data() {
    return {
      bulkActionDrawer: false,
      actionButton: false,
      tags: [],
      status: '',
      priority: '',
      type: '',
      selectedAgent: '',
      supportEmailList: [],
      editorHTML: "",
      deleteAttachmentIds: [],
      fromEmailAddress: '',
      replyTemplateFileIds: [],
      dialog: {
        attrs: {
          show: false,
          title: "Bulk Update Tickets",
          loading: false,
          confirmBtn: true,
          confirmationText: "Update",
          maxWidth: 550,
          type: 'warning',
          message: 'Warning: You cannot undo this action.',
        },
        on: {
          confirm: this.onBulkUpdateConfirmation,
          cancel: () => {
            this.dialog.attrs.show = false;
            setTimeout(() => { this.bulkActionDrawer = true })
          },
        },
      },
      tagName: '',
      loadSupportEmail: false,
      newTagLoading: false,
      tagSearch: null,
      tagList: [],
      tagLoading: false,
      tagPageNo: 1,
    };
  },
  computed: {
    associatedField() {
      return this.$store.getters["tickets/associatedField"];
    },
    filterStatusList() {
      return this.associatedField.statusList.filter(status => status.name !== "new");
    },
  },
  mounted() {
    this.fetchTags('')
    this.getSupportEmails();
  },
  methods: {
    /**
     * Enable bulk action update button
     */
    enableUpdate() {
      this.actionButton = !!(
        this.selectedAgent ||
        this.status ||
        this.priority ||
        this.type ||
        this.tags.length > 0 ||
        this.editorHTML.length
      );
    },

    /**
     * Open bulk action drawer
     */
    onBulkClick() {
      this.bulkActionDrawer = true;
    },

    /**
     * Get editor HTML content
     * @param {string} htmlData - HTML content of the editor
     */
    getEditorHTML(htmlData) {
      if (htmlData.length > 0) {
        this.enableUpdate();
      }
      this.editorHTML = htmlData;
    },

    /**
     * Get editor instance
     * @param {object} editor - Editor instance
     */
    getInstance(editor) {
      this.editorInstance = editor;
    },

    /**
     * Update bulk action confirmation dialog
     */
    onUpdate () {
      // Show dialog
      this.dialog.attrs.show = true;
      // Close bulk action drawer
      this.bulkActionDrawer = false;
      // Get current subtitle
      let subtitle = this.dialog.attrs.subtitle;
      // Define subtitle data
      const subtitleData = {
        'Bulk Reply': !!this.editorHTML,
        'Priority': this.priority.name,
        'Status': this.status.name,
        'Agent': this.selectedAgent.agent_name,
        'Ticket Type': this.type.name,
        'Tags': this.tags.map(tag => tag.name).join(', ')
      };
      // Update subtitle
      subtitle = `Are you sure you want to proceed with these updates?
                  You are about to perform the following actions on <b>${this.selectedTickets.length}</b> tickets.`;
      let listHTML = '<ul class="mt-4">';
      for (let key in subtitleData) {
        // Check if data is not null, undefined, or empty
        if (subtitleData[key] !== undefined && subtitleData[key] !== null && subtitleData[key].length !== 0) {
          // Check if bulk reply exists
          if (key === 'Bulk Reply') {
            if (subtitleData[key]) {
              listHTML += `<li>${key}</li>`;
            }
          } else {
            // Add data to list HTML
            listHTML += `<li>${key} > `;
            // Check if data is an array
            if (Array.isArray(subtitleData[key])) {
              // Capitalize and add data
              listHTML += capitalizeAndJoin(subtitleData[key]);
            } else {
              if (subtitleData[key] === '--') {
                listHTML += 'Unassigned'
              } else {
                let itemData = subtitleData[key].replace(/_/g, ' ')
                listHTML += itemData.charAt(0).toUpperCase() + itemData.slice(1);
              }
            }
            listHTML += '</li>';
          }
        }
      }
      listHTML += '</ul>';

      // Add list HTML to subtitle
      subtitle += listHTML;
      // Update dialog subtitle
      this.dialog.attrs.subtitle = subtitle;
    },

    /**
     * Capitalize the first letter of each word in array and join with comma
     * @param {array} array - Array of strings
     * @returns {string} - Comma separated string with each word's first letter capitalized
     */
    capitalizeAndJoin(array) {
      return array.map(word => word.replace(/_/g, ' ').word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    },

    /**
     * Perform bulk update action
     */
    onBulkUpdateConfirmation() {
      const valid = this.$refs.bulkActionForm.validate();
      if (!valid) return;

      this.actionButton = false;
      this.dialog.attrs.loading = true;

      const data = {
        ids: this.selectedTickets.map((ticket) => ticket.id),
        priority: this.priority.name,
        status: this.status.name,
        agent_id: this.selectedAgent.id === "blank" ? " " : this.selectedAgent.id,
        ticket_type_id: this.type.id === "blank" ? " " : this.type.id,
        tag_ids: this.tags.map((tag) => tag.id),
        reply: {
          body: this.editorHTML,
          bcc_emails: [],
          cc_emails: [],
          comment_type: "reply",
          from_email: this.fromEmailAddress,
          incoming: false,
          private: false,
          to_emails: [''], //Key required in case of formData
          attachment_ids: this.replyTemplateFileIds,
        },
      };
      
      let payload = null;
      let config = {};

      if (this.dropedFiles.length) {
        const formData = new FormData();
        delete data.reply.attachment_ids
        this.appendToFormData(data, formData);

        // Add attachment ids
        this.replyTemplateFileIds.forEach((fileId) =>
          formData.append("reply[attachment_ids][]", fileId)
        );

        // Add dropped files
        this.dropedFiles.forEach((file) =>
          formData.append("reply[attachments][]", file)
        );

        payload = formData;
        config = {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        };
      } else {
        payload = data;
      }

      $tickets.bulkUpdate(payload, config).then((response) => {
        this.$store.dispatch("ui/snackbar", [
          {
            message: `Bulk Update has been started. This might take a while.`,
            type: "success",
          },
        ]);
        this.resetFields();
        this.$emit("getCustomViewList");
        this.dialog.attrs.show = false;
      }).catch((error) => {
        this.$store.dispatch("ui/snackbar", [
          {
            message:error.response.data.errors,
            type: "error",
          },
        ]);
      }).finally(() => {
        this.dialog.attrs.loading = false;
      });
    },

    /**
     * Append data to FormData
     * @param {object} data - Data to be appended
     * @param {object} formData - FormData object
     * @param {string} parentKey - Parent key (if exists)
     */
    appendToFormData(data, formData, parentKey = '') {
      for (let key in data) {
        if (Array.isArray(data[key])) {
          data[key].forEach(item => {
            formData.append(parentKey === '' ? `${key}[]` : `${parentKey}[${key}][]`, item);
          });
        } else if (typeof data[key] === 'object' && data[key] !== null) {
            this.appendToFormData(data[key], formData, key);
        } else {
            formData.append(parentKey === '' ? key : `${parentKey}[${key}]`, data[key]);
        }
      }
    },

    /**
     * Get support emails
     */
    getSupportEmails() {
      const payload = {};
      this.loadSupportEmail = true;
      $mailbox.fetchList(payload, {}).then((response) => {
        this.supportEmailList = response.data.mailboxes.filter((email) => {
          return email.verified_at !== null;
        });
        const defaultFrom = this.supportEmailList[0]
        this.fromEmailAddress = defaultFrom.email;
        this.supportEmailName = defaultFrom.name ? defaultFrom.name : "";
      }).finally(() => {
        this.loadSupportEmail = false;
      });
    },

    /**
     * Set support email
     * @param {object} item - Selected support email
     */
    setSupportEmail(item) {
      this.fromEmailAddress = item.email;
      this.supportEmailName = item.name ? item.name : "";
    },

    /**
     * Update editor body
     * @param {object} data - Data to be updated
     */
    updateBody(data) {
      if (data) {
        if (this.editorInstance) {
          const viewFragment = this.editorInstance.data.processor.toView(
            data.body
          );
          this.editorHTML =  data.body;
          const modelFragment = this.editorInstance.data.toModel(viewFragment);

          this.editorInstance.model.insertContent(
            modelFragment,
            this.editorInstance.model.document.selection
          );
        }

        this.attachmentFiles = data.attachment_info;
        if (data.attachment_info.length) {
          data.attachment_info.forEach((item) => {
            this.replyTemplateFileIds.push(item.attachment_id);
          });
        }
      }
    },

    /**
     * Cancel bulk action
     */
    onCancel () {
      this.bulkActionDrawer = false;
      this.resetFields();
    },

    /**
     * Reset fields
     */
    resetFields () {
      this.editorHTML = '';
      this.$refs.bulkActionForm.reset();
      this.$emit("resetSelectedTickets");
    },

    /**
     * Reset tag pagination page number and fetch tags based on search query
     */
    searchTagItems() {
      this.tagPageNo = 1; // Reset pagination page number
      this.fetchTags(this.tagSearch); // Fetch tags based on search query
    },

    /**
     * Fetch tags based on search query
     * @param {string} search - Search query for tags
     */
    fetchTags(search) {
      this.tagLoading = true; // Set tag loading state to true
      const data = {
        page: this.tagPageNo,
        per_page: 10,
        q: {
          name_cont: search,
          m: "or",
        },
      };
      $tag.fetchList(data, {}).then(response => {
        this.tagList = response.data.tag; // Set tag list
        this.pagination = response.data.pagination; // Set pagination data
      }).finally(()=>{
        this.tagLoading = false; // Set tag loading state to false
      });
    },

    /**
     * Add new tag item
     */
    onCreateTag() {
      if (this.tagSearch) {
        this.newTagLoading = true; // Set new tag loading state to true
        let payload = {
          tag: {
            name: this.tagSearch,
          }
        };
        const config = {};
        $tag.create(payload, config).then(async (response) => {
          const tag = response.data; // New tag data
          this.tagList.push(tag); // Add new tag to tag list
          this.tags.push(tag); // Add new tag to selected tags
          this.enableUpdate();
        }).finally(() => {
          this.tagSearch = null; // Reset tag search query
          this.newTagLoading = false; // Set new tag loading state to false
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.ck-editor-card-border {
  border-color: #9e9e9e;
  min-height: 250px;
}
.transform-none {
  text-transform: none;
}
</style>